module.exports = __webpack_public_path__ + "img/go-button.ae99c408.svg";